import { useEffect } from 'react';

/**
 * @name `useOnMountAndUnmount`
 *
 * `useEffect()` with an empty dependencies array does not call the function
 * on unmount. This hook handles that behavior.
 */
const useOnMountAndUnmount = (cb: () => void) => {
  useEffect(() => {
    cb();
    return cb;
  }, []);
};

export default useOnMountAndUnmount;
